<template>
  <!-- 积分订单 -->
  <div class="integralList">
    <!-- 面包屑导航 -->
    <crumbs-bar
      @refresh="handleRefresh"
      :crumbsList="['积分商城', $route.meta.title]"
    >
      <template slot="controls">
        <el-button type="primary" icon="el-icon-download" @click="exportData"
          >导出数据</el-button
        >
      </template>
    </crumbs-bar>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <el-date-picker
          type="date"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          v-model="searchForm.start"
          clearable
          style="width: 200px; margin-right: 5px"
          placeholder="选择开始日期"
        >
        </el-date-picker>
        <el-date-picker
          type="date"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          v-model="searchForm.end"
          clearable
          style="width: 200px; margin-right: 5px"
          placeholder="选择结束日期"
        >
        </el-date-picker>
        <el-input
          style="width: 200px; margin-right: 5px"
          clearable
          placeholder="输入订单编号"
          v-model="searchForm.name"
        >
        </el-input>
        <el-button type="primary" icon="el-icon-search" @click="getTableData(1)"
          >搜索</el-button
        >
      </template>
    </search-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe
      border
      height="calc(100% - 130px)"
      tooltip-effect="dark"
      style="width: 100%"
    >
      <el-table-column label="序号" align="center" width="50">
        <template slot-scope="scope">
          <span>{{ (currPage - 1) * pageSize + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="id"
        show-overflow-tooltip
        label="单据编号"
      >
      </el-table-column>
      <el-table-column
        prop="name"
        align="center"
        show-overflow-tooltip
        label="单位名称"
      >
      </el-table-column>
      <el-table-column
        prop="data"
        label="日期"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="num"
        label="数量"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="integral"
        label="积分"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="contact"
        label="收件人"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="phone"
        label="手机号"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="address"
        label="地址"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>

      <el-table-column
        prop="status"
        label="订单状态"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-tag v-show="scope.row.status == 0" type="success">已兑换</el-tag>
          <el-tag v-show="scope.row.status != 0">{{ scope.row.status }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            type="primary"
            style="padding: 2px 3px"
            plain
            @click="getDetails(scope.row)"
            >查看明细
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      :allPage="allPage"
      :pageSize="pageSize"
      :currIndex="currPage"
      @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"
      layout="total, prev, pager, next, jumper"
    ></pagination>
    <!-- 查看明细dialog -->
    <el-dialog
      title="积分订单详情"
      :visible.sync="detailDialog"
      :close-on-click-modal="$store.state.closeOnClickModal"
      :close-on-press-escape="$store.state.closeOnPresEscape"
      width="70%"
    >
      <el-table
        :data="detailList"
        stripe
        border
        tooltip-effect="dark"
        height="400px"
      >
        <el-table-column
          prop="djbh"
          label="单据编号"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="goodsname"
          label="商品名称"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="rq"
          label="日期"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="ontime"
          label="时间"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="dw"
          label="单位"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="shl"
          label="数量"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="jf"
          label="积分"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="jf"
          label="积分"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "integralList",
  data() {
    return {
      entId: "",

      /**表格数据 */
      // {
      //   id:"单据编号",
      //   name:"单位名称",
      //   data:"日期",
      //   time:"时间",
      //   salesman:"业务员",
      //   num:"数量",
      //   integral:"积分数",
      //   status:"订单状态"
      // }
      tableData: [],
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,
      /**搜索表单 */
      searchForm: {
        start: this.$formatDate(new Date().getTime() - 2592000000),
        end: this.$formatDate(new Date()),
        name: "",
      },
      /**查看明细dialog */
      detailDialog: false,
      detailList: [], //明细商品列表
    };
  },
  mounted() {
    this.entId = localStorage.getItem("entId");
    this.getTableData();
  },
  methods: {
    /**获取表格 */
    getTableData(num) {
      this.currPage = num == 1 ? 1 : this.currPage;
      this.$requestSys({
        url:
          "jfddcx/ashx/dd_select_hz.ashx?username=" +
          encodeURIComponent(this.searchForm.name) +
          "&page=" +
          encodeURIComponent(this.currPage) +
          "&ksRq=" +
          encodeURIComponent(this.searchForm.start) +
          "&jsRq=" +
          encodeURIComponent(this.searchForm.end) +
          "&pageSize=" +
          encodeURIComponent(this.pageSize),
        method: "Post",
      })
        .then((res) => {
          this.tableData = [];
          if (res.flag == 0) {
            this.allPage = res.pageCount;
            this.tableData = res.data.map((item) => ({
              id: item.djbh,
              name: item.businessname,
              data: item.rq + " " + item.ontime,
              time: item.ontime,
              salesman: item.salesman,
              num: item.shl,
              integral: item.totaljf,
              status: item.zt,
              address: item.address,
              phone: item.phone,
              contact: item.contact,
            }));
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**刷新表格数据 */
    handleRefresh() {
      this.getTableData();
    },
    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
      this.getTableData();
    },
    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.getTableData();
    },
    /**获取订单明细 */
    getDetails(row) {
      this.$requestSys({
        url: "jfddcx/ashx/ddmx.ashx?djbh=" + encodeURI(row.id),
        method: "Post",
      })
        .then((res) => {
          if (res.flag == 0) {
            this.detailList = res.data;
            this.detailDialog = true;
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    // 导出数据
    exportData() {
      let data = {
        entId: localStorage.getItem("entId"),
        type: "GetJfOrderToExcel", // getJFDD
        var: this.searchForm.name,
        page: 1,
        pageSize: 60000,
        ksRq: this.searchForm.start,
        jsRq: this.searchForm.end,
      };
      let proc = "Proc_Premiun_details";
      window.location.href =
        this.baseUrl +
        "Order/NoPIGExprot?json=" +
        encodeURIComponent(JSON.stringify(data)) +
        "&proc=" +
        encodeURIComponent(proc) +
        "&name=积分订单";
    },
  },
};
</script>

<style scoped>
.integralList {
  width: 100%;
  height: 100%;
}
</style>
